import React from "react"
import { Text, Tooltip, Box } from "@chakra-ui/react"
import { GuestEmail } from "sharedTypes"

type Props = {
  emails: GuestEmail[];
}

const EmailCampaignCell = ({ emails }: Props) => {
  if (!emails.length) return null

  const campaignTitles = [
    ...new Set(emails.map((email) => email.title).filter(Boolean)),
  ] as string[]

  if (!campaignTitles.length) return null

  const displayText = campaignTitles.join(", ")

  if (campaignTitles.length > 1) {
    return (
      <Tooltip
        label={(
          <Box>
            {campaignTitles.map((title, i) => (
              <Text key={i} fontSize="sm">
                {title}
              </Text>
            ))}
          </Box>
        )}
      >
        <Text fontSize="sm" noOfLines={1} title={displayText}>
          {displayText}
        </Text>
      </Tooltip>
    )
  }

  return (
    <Text fontSize="sm" noOfLines={1} title={displayText}>
      {displayText}
    </Text>
  )
}

export default EmailCampaignCell
